import { render, staticRenderFns } from "./macro.vue?vue&type=template&id=c84974b4&scoped=true&"
import script from "./macro.vue?vue&type=script&lang=js&"
export * from "./macro.vue?vue&type=script&lang=js&"
import style0 from "./macro.vue?vue&type=style&index=0&id=c84974b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84974b4",
  null
  
)

export default component.exports